import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SwiperCore, { A11y, Lazy, Navigation, Pagination } from 'swiper';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { useGetDashboardEmptyLegs } from 'untils/hook/emptyLeg/emptyLeg.hook';
import {
  CustomPagination,
  MoreLink,
  Section,
  SectionHeader,
  SectionHeaderText,
  SectionSubHeaderText,
} from '../Home.style';
import Card from './Card';

SwiperCore.use([Lazy, Navigation, A11y, Pagination]);

const TestContainer = styled(Section)`
  --inner-padding: 8px;
  margin-top: 60px;
  margin-bottom: 120px;
  padding: 0 calc(var(--home-inline-padding) - var(--inner-padding));
  .swiper-container {
    padding: var(--inner-padding);
  }
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
    margin-right: 24px; /* space between */
  }
  @media (max-width: 1380px) {
    padding-right: 0;
  }
  @media (max-width: 737px) {
    margin-top: 40px;
    margin-bottom: 40px;
    .swiper-slide {
      margin-right: 16px;
    }
  }
`;

const EmptyLegBody = styled.div`
  --empty-margin: calc(24px - var(--inner-padding));

  margin-top: var(--empty-margin);
  margin-bottom: var(--empty-margin);
  min-height: 222px;

  @media (max-width: 757px) {
    --empty-margin: calc(16px - var(--inner-padding));
  }
`;

const TestHeader = styled(SectionHeader)`
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: flex-end;
  padding: 0 var(--inner-padding);
  margin-bottom: 8px;
`;

const DisclaimerText = styled(SectionHeader)`
  font-size: var(--fs-400);
`;

const EmptyLegComponent = () => {
  const { isLoading, data } = useGetDashboardEmptyLegs();

  return (
    <TestContainer>
      <TestHeader>
        <div>
          <Link to={'/emptyLeg'}>
            <SectionHeaderText>Flight Offers</SectionHeaderText>
          </Link>
          <SectionSubHeaderText>
            Check out cheapest private jet charter offers. Book while {"they're"} available.
          </SectionSubHeaderText>
          <DisclaimerText>
            *All advertised rates are net prices and are subject to taxes, regulatory fees, or other
            charges, which may vary based on routing and availability*
          </DisclaimerText>
        </div>
        <CustomPagination id="empty-pagination" />
      </TestHeader>
      <EmptyLegBody>
        {isLoading && <div>Loading...</div>}
        {data && (
          <Swiper
            slidesPerView="auto"
            lazy
            pagination={{
              renderCustom: function (_, current, total) {
                return `<span>${current}</span> / <span>${total}</span>`;
              },
              type: 'custom',
              el: '#empty-pagination',
            }}
          >
            {data.map((item) => {
              return (
                <SwiperSlide key={item.Id}>
                  <Card item={item} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </EmptyLegBody>
      <div>
        <MoreLink to={'/emptyLeg'}>More...</MoreLink>
      </div>
    </TestContainer>
  );
};

export default EmptyLegComponent;
